import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, Switch, Button, Avatar } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import apiRequest from "apiRequest";

function BanksTable({ rows, onToggleStatus, editClick, deleteClick }) {
  const data = Array.isArray(rows) ? rows : [];

  return (
    <TableContainer component={Paper} style={{ marginTop: 4 }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>Name Er</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Name Fr</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>
              Description Er</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>
              Description Fr</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Branch Code</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Address</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
          </TableRow>
          {data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} align="center">
                No customers found
              </TableCell>
            </TableRow>
          ) : (
            data.map((customer) => {
              const customerId = customer.id ?? customer._id;
              const joinedAt = customer.createdAt || customer.created_at || customer.joinedAt;
              const totalOrders = customer.total_orders ?? customer.orders_count ?? customer.ordersTotal ?? 0;
              const avatarSource = customer?.profile ? `${apiRequest.BASE_URL}/${customer.profile}` : undefined;

              return (
                <TableRow key={customerId} hover>
                  <TableCell>
                    <MDBox display="flex" alignItems="center">
                      {/* <Avatar src={avatarSource} sx={{ width: 36, height: 36, mr: 1 }} /> */}
                      <MDTypography variant="button" fontWeight="medium">
                        {customer?.name_en || "-"}
                      </MDTypography>
                    </MDBox>
                  </TableCell>
                  <TableCell>{customer.name_fr || "-"}</TableCell>
                  <TableCell>{customer.description_en || "-"}</TableCell>
                  <TableCell>{customer.description_fr || "-"}</TableCell>
                  <TableCell>{customer.branch_code || "-"}</TableCell>
                  <TableCell>{customer.address || "-"}</TableCell>
                  <TableCell>
                    <Switch
                      checked={customer.status === "active"}  // status for this row
                      onChange={() => onToggleStatus(customer.id, customer.status)} // pass correct id & status
                      color="primary"
                    />
                  </TableCell>


                  <TableCell>
                    <Button
                      onClick={() => editClick(customerId, customer)}
                      color="primary"
                      size="small"
                      style={{ textTransform: "uppercase" }}
                    >
                      Edit
                    </Button>
                  </TableCell>
                  {/* delete button */}
                  <TableCell>
                    <Button
                      color="error"
                      onClick={() => customerId && deleteClick(customerId)}
                      size="small"
                      disabled={!customerId}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default BanksTable;
